module.exports = __webpack_public_path__ + "img/2020-01-17.c56ed01f.jpg";